import { Loan } from "gql/graphql";
import { LOAN_PHASES } from "scenes/Private/Dashboard/LoanPhases.constanst";
import { processBorrowerTaskItems } from "./processorBorrowerTaskItem";
import { processLenderTaskItems } from "./processorLenderTaskItem";
import { determinePhaseState } from "./processorPhaseStates";


export const calculateLoanProgress = (loan: Loan, rulesTasksCards: any[], loanDocs: any[]) => {
  const phases = JSON.parse(JSON.stringify(LOAN_PHASES));

  if (!rulesTasksCards) return [];

  phases.forEach((phase: any) => {
    const filteredRulesTaskCards = processBorrowerTaskItems(
      phase, 
      rulesTasksCards, 
      loanDocs, 
      loan
    );

    processLenderTaskItems(
      phase, 
      loanDocs, 
      rulesTasksCards, 
      loan
    );

    // Determinar estado de la fase
    const { state, stateName } = determinePhaseState(
      filteredRulesTaskCards || [], 
      loanDocs, 
      phase
    );
    phase.state = state;
    phase.stateName = stateName;
  });

  return phases;
};